import { n as noop, s as safe_not_equal, a as subscribe, r as run_all, i as is_function, g as get_store_value, S as SvelteComponent, b as init, c as not_equal, e as empty, d as insert, f as group_outros, t as transition_out, h as check_outros, j as transition_in, k as detach, l as component_subscribe, m as create_component, o as mount_component, p as destroy_component, q as tick, u as create_slot, v as assign, w as element, x as set_attributes, y as toggle_class, z as listen, A as update_slot, B as get_spread_update, C as compute_rest_props, D as exclude_internal_props } from '../common/index-a5f685d7.js';

// Listen to location changes that are triggered by:
// - pushState
// - replaceState
// - onpopstate
// - onhashchange
const LOCATION_CHANGE = 'svelterouterlocationchange';
const originalPushState = history.pushState;
const originalReplaceState = history.replaceState;
let prevLocation = '';
function dispatch() {
    if (window.location.href !== prevLocation) {
        window.dispatchEvent(new CustomEvent(LOCATION_CHANGE));
        prevLocation = window.location.href;
    }
}
history.pushState = function (...args) {
    originalPushState.apply(this, args);
    dispatch();
};
history.replaceState = function (...args) {
    originalReplaceState.apply(this, args);
    dispatch();
};
window.addEventListener('popstate', dispatch);
window.addEventListener('hashchange', dispatch);

const subscriber_queue = [];
function readable(value, start) {
  return {
    subscribe: writable(value, start).subscribe
  };
}
function writable(value, start = noop) {
  let stop;
  const subscribers = [];
  function set(new_value) {
    if (safe_not_equal(value, new_value)) {
      value = new_value;
      if (stop) {
        const run_queue = !subscriber_queue.length;
        for (let i = 0; i < subscribers.length; i += 1) {
          const s = subscribers[i];
          s[1]();
          subscriber_queue.push(s, value);
        }
        if (run_queue) {
          for (let i = 0; i < subscriber_queue.length; i += 2) {
            subscriber_queue[i][0](subscriber_queue[i + 1]);
          }
          subscriber_queue.length = 0;
        }
      }
    }
  }
  function update(fn) {
    set(fn(value));
  }
  function subscribe2(run, invalidate = noop) {
    const subscriber = [run, invalidate];
    subscribers.push(subscriber);
    if (subscribers.length === 1) {
      stop = start(set) || noop;
    }
    run(value);
    return () => {
      const index = subscribers.indexOf(subscriber);
      if (index !== -1) {
        subscribers.splice(index, 1);
      }
      if (subscribers.length === 0) {
        stop();
        stop = null;
      }
    };
  }
  return {set, update, subscribe: subscribe2};
}
function derived(stores, fn, initial_value) {
  const single = !Array.isArray(stores);
  const stores_array = single ? [stores] : stores;
  const auto = fn.length < 2;
  return readable(initial_value, (set) => {
    let inited = false;
    const values = [];
    let pending = 0;
    let cleanup = noop;
    const sync = () => {
      if (pending) {
        return;
      }
      cleanup();
      const result = fn(single ? values[0] : values, set);
      if (auto) {
        set(result);
      } else {
        cleanup = is_function(result) ? result : noop;
      }
    };
    const unsubscribers = stores_array.map((store, i) => subscribe(store, (value) => {
      values[i] = value;
      pending &= ~(1 << i);
      if (inited) {
        sync();
      }
    }, () => {
      pending |= 1 << i;
    }));
    inited = true;
    sync();
    return function stop() {
      run_all(unsubscribers);
      cleanup();
    };
  });
}

function regexparam(str, loose) {
  if (str instanceof RegExp)
    return {keys: false, pattern: str};
  var c, o, tmp, ext, keys = [], pattern = "", arr = str.split("/");
  arr[0] || arr.shift();
  while (tmp = arr.shift()) {
    c = tmp[0];
    if (c === "*") {
      keys.push("wild");
      pattern += "/(.*)";
    } else if (c === ":") {
      o = tmp.indexOf("?", 1);
      ext = tmp.indexOf(".", 1);
      keys.push(tmp.substring(1, !!~o ? o : !!~ext ? ext : tmp.length));
      pattern += !!~o && !~ext ? "(?:/([^/]+?))?" : "/([^/]+?)";
      if (!!~ext)
        pattern += (!!~o ? "?" : "") + "\\" + tmp.substring(ext);
    } else {
      pattern += "/" + tmp;
    }
  }
  return {
    keys,
    pattern: new RegExp("^" + pattern + (loose ? "(?=$|/)" : "/?$"), "i")
  };
}

function getBasePath() {
    return document.getElementsByTagName('base').length > 0
        ? document.baseURI.replace(window.location.origin, '')
        : '/';
}
function parseLocationInput(to) {
    const url = new URL(to, 'https://example.com');
    return {
        path: to.startsWith('/') ? url.pathname : undefined,
        search: url.search,
        hash: url.hash
    };
}
/** Replace dynamic segments in path, e.g. `/user/:id` => `/user/foo` */
function replacePathParams(path, params) {
    return path.replace(/:([^/]+)/g, (o, v) => { var _a; return (_a = params[v]) !== null && _a !== void 0 ? _a : o; });
}
/** Makes sure path has leading "/" and no trailing "/" */
function formatPath(path) {
    if (path.endsWith('/')) {
        path = path.slice(0, -1);
    }
    if (!path.startsWith('/')) {
        path = '/' + path;
    }
    return path;
}
/** Joins multiple path and also formats it */
function joinPaths(...paths) {
    return paths
        .map(formatPath)
        .filter((v) => v !== '/')
        .join('');
}
function ensureTrailingSlash(path) {
    if (!path.endsWith('/')) {
        path += '/';
    }
    return path;
}
function handleThunk(thunk) {
    return typeof thunk === 'function' ? thunk() : thunk;
}
function handleComponentThunk(thunk) {
    // Svelte components are classes/functions so thunk won't actually work.
    // The workaround is by assuming this syntax `() => import` to be used.
    // Since lambda has no prototype, so we check it before calling thunk.
    return typeof thunk === 'function' && !('prototype' in thunk)
        ? thunk()
        : thunk;
}
function handlePromisable(promisable, callback) {
    if (promisable instanceof Promise) {
        promisable.then(callback);
    }
    else {
        callback(promisable);
    }
}

class RouteMatcher {
    constructor(routes = []) {
        this.matchDatas = [];
        this.buildDatas(routes);
    }
    /** Finds a route based on target path and the computed matchers. */
    matchRoute(path) {
        // Add trailing slash to route path so it properly matches nested routes too.
        // e.g. /foo should match /foo/*
        const matchPath = ensureTrailingSlash(formatPath(path));
        for (const matchData of this.matchDatas) {
            const params = {};
            const matchResult = matchPath.match(matchData.pattern);
            if (matchResult) {
                for (let i = 0; i < matchData.keys.length; i++) {
                    params[matchData.keys[i]] = matchResult[i + 1];
                }
                if ('wild' in params) {
                    params.wild = formatPath(params.wild);
                }
                return {
                    path,
                    params,
                    matched: matchData.matched
                };
            }
        }
    }
    /**
     * Convert the routes as datas that contains information for path matching.
     * This will recursively traverse child routes and flatten into `matchDatas`.
     */
    buildDatas(routes, parentData = { path: '', matched: [] }) {
        routes.forEach((route) => {
            var _a;
            // Cumulative metadata when traversing parents
            const parent = {
                path: joinPaths(parentData.path, route.path),
                matched: parentData.matched.concat(route)
            };
            if ((_a = route.children) === null || _a === void 0 ? void 0 : _a.length) {
                this.buildDatas(route.children, parent);
            }
            else {
                this.matchDatas.push(Object.assign(Object.assign({}, parent), regexparam(parent.path)));
            }
        });
        // Make sure "/" doesn't fall through if the routes' paths do.
        // Example route config:
        // "/foo"
        // - "/bar"
        // match('/foo') should render "/foo" component but with empty child
        if (!routes.some((route) => ['', '/', '*', '/*'].includes(route.path))) {
            this.matchDatas.push(Object.assign(Object.assign({}, parentData), regexparam(parentData.path)));
        }
    }
}

class Router {
    constructor(routes) {
        this.routeMatcher = new RouteMatcher(routes);
        this.currentRoute = readable(this.getCurrentRoute(), (set) => {
            const handleChange = () => set(this.getCurrentRoute());
            window.addEventListener(LOCATION_CHANGE, handleChange);
            return () => window.removeEventListener(LOCATION_CHANGE, handleChange);
        });
        // Format URL on page load
        this.navigate(this.getCurrentLocationInput(), true);
    }
    navigate(to, replace = false) {
        if (typeof to === 'number') {
            history.go(to);
            return;
        }
        if (typeof to === 'string') {
            to = parseLocationInput(to);
        }
        const url = this.createUrl(this.replaceParams(to));
        if (replace) {
            history.replaceState(url, '', url);
        }
        else {
            history.pushState(url, '', url);
        }
    }
    /** Returns a readable store that contains the given link's information */
    createLink(to) {
        const input = typeof to === 'string' ? parseLocationInput(to) : to;
        return derived(this.currentRoute, ($currentRoute) => {
            const replacedInput = this.replaceParams(input, $currentRoute.params);
            const href = this.createLinkHref(replacedInput);
            const path = this.getPath(replacedInput);
            if (path == null) {
                return {
                    href,
                    isActive: false,
                    isExactActive: false
                };
            }
            const formattedPath = formatPath(path);
            const routePath = $currentRoute.path;
            return {
                href,
                isActive: routePath.startsWith(formattedPath),
                isExactActive: routePath === formattedPath
            };
        });
    }
    getCurrentRoute() {
        var _a, _b;
        const currentPath = this.getCurrentPath();
        const matchedRoute = this.routeMatcher.matchRoute(currentPath);
        return {
            path: currentPath,
            search: new URLSearchParams(window.location.search),
            hash: window.location.hash,
            params: (_a = matchedRoute === null || matchedRoute === void 0 ? void 0 : matchedRoute.params) !== null && _a !== void 0 ? _a : {},
            matched: (_b = matchedRoute === null || matchedRoute === void 0 ? void 0 : matchedRoute.matched) !== null && _b !== void 0 ? _b : []
        };
    }
}

const basePath = /*#__PURE__*/ getBasePath();
class PathRouter extends Router {
    getCurrentPath() {
        return formatPath(window.location.pathname.replace(basePath, ''));
    }
    getCurrentLocationInput() {
        return {
            path: this.getCurrentPath(),
            hash: window.location.hash,
            search: window.location.search
        };
    }
    getPath(to) {
        return to.path;
    }
    createUrl(to) {
        var _a;
        const url = new URL(window.location.href);
        if (to.path) {
            url.pathname = joinPaths(basePath, to.path);
        }
        url.search = to.search
            ? '?' + new URLSearchParams(to.search).toString()
            : '';
        url.hash = (_a = to.hash) !== null && _a !== void 0 ? _a : '';
        return url.toString();
    }
    createLinkHref(to) {
        var _a, _b, _c;
        const path = (_a = to.path) !== null && _a !== void 0 ? _a : '';
        const search = (_b = to.search) !== null && _b !== void 0 ? _b : '';
        const hash = (_c = to.hash) !== null && _c !== void 0 ? _c : '';
        return joinPaths(basePath, path) + search + hash;
    }
    replaceParams(to, params) {
        const newTo = Object.assign({}, to);
        const routeParams = params !== null && params !== void 0 ? params : get_store_value(this.currentRoute).params;
        if (newTo.path) {
            newTo.path = replacePathParams(newTo.path, routeParams);
        }
        return newTo;
    }
}

let globalRouter;
const writableRoute = writable({
    path: '',
    params: {},
    matched: [],
    search: new URLSearchParams(),
    hash: ''
});
const route = { subscribe: writableRoute.subscribe };
const navigate = function () {
    if (globalRouter != null) {
        // @ts-expect-error
        return globalRouter.navigate(...arguments);
    }
    else {
        throw new Error('Router must be initialized before calling navigate');
    }
};
const createLink = function () {
    if (globalRouter != null) {
        // @ts-expect-error
        return globalRouter.createLink(...arguments);
    }
    else {
        throw new Error('Router must be initialized before calling createLink');
    }
};
function initPathRouter(routes) {
    initRouter(new PathRouter(routes));
}
function initRouter(router) {
    if (globalRouter == null) {
        globalRouter = router;
        globalRouter.currentRoute.subscribe((v) => writableRoute.set(v));
    }
    else {
        throw new Error('Router already initialized. Cannot re-initialize router.');
    }
}

/* node_modules\@bjornlu\svelte-router\dist\components\RouterView.svelte generated by Svelte v3.38.3 */

function create_if_block(ctx) {
	let current_block_type_index;
	let if_block;
	let if_block_anchor;
	let current;
	const if_block_creators = [create_if_block_1, create_if_block_3];
	const if_blocks = [];

	function select_block_type(ctx, dirty) {
		if (/*component*/ ctx[2] != null) return 0;
		if (/*hasChildren*/ ctx[3]) return 1;
		return -1;
	}

	if (~(current_block_type_index = select_block_type(ctx))) {
		if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
	}

	return {
		c() {
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if (~current_block_type_index) {
				if_blocks[current_block_type_index].m(target, anchor);
			}

			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type(ctx);

			if (current_block_type_index === previous_block_index) {
				if (~current_block_type_index) {
					if_blocks[current_block_type_index].p(ctx, dirty);
				}
			} else {
				if (if_block) {
					group_outros();

					transition_out(if_blocks[previous_block_index], 1, 1, () => {
						if_blocks[previous_block_index] = null;
					});

					check_outros();
				}

				if (~current_block_type_index) {
					if_block = if_blocks[current_block_type_index];

					if (!if_block) {
						if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
						if_block.c();
					} else {
						if_block.p(ctx, dirty);
					}

					transition_in(if_block, 1);
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				} else {
					if_block = null;
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (~current_block_type_index) {
				if_blocks[current_block_type_index].d(detaching);
			}

			if (detaching) detach(if_block_anchor);
		}
	};
}

// (37:24) 
function create_if_block_3(ctx) {
	let routerview;
	let current;
	routerview = new RouterView({ props: { depth: /*depth*/ ctx[0] + 1 } });

	return {
		c() {
			create_component(routerview.$$.fragment);
		},
		m(target, anchor) {
			mount_component(routerview, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const routerview_changes = {};
			if (dirty & /*depth*/ 1) routerview_changes.depth = /*depth*/ ctx[0] + 1;
			routerview.$set(routerview_changes);
		},
		i(local) {
			if (current) return;
			transition_in(routerview.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(routerview.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(routerview, detaching);
		}
	};
}

// (31:2) {#if component != null}
function create_if_block_1(ctx) {
	let switch_instance;
	let switch_instance_anchor;
	let current;
	var switch_value = /*component*/ ctx[2];

	function switch_props(ctx) {
		return {
			props: {
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		};
	}

	if (switch_value) {
		switch_instance = new switch_value(switch_props(ctx));
	}

	return {
		c() {
			if (switch_instance) create_component(switch_instance.$$.fragment);
			switch_instance_anchor = empty();
		},
		m(target, anchor) {
			if (switch_instance) {
				mount_component(switch_instance, target, anchor);
			}

			insert(target, switch_instance_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const switch_instance_changes = {};

			if (dirty & /*$$scope, depth, hasChildren*/ 73) {
				switch_instance_changes.$$scope = { dirty, ctx };
			}

			if (switch_value !== (switch_value = /*component*/ ctx[2])) {
				if (switch_instance) {
					group_outros();
					const old_component = switch_instance;

					transition_out(old_component.$$.fragment, 1, 0, () => {
						destroy_component(old_component, 1);
					});

					check_outros();
				}

				if (switch_value) {
					switch_instance = new switch_value(switch_props(ctx));
					create_component(switch_instance.$$.fragment);
					transition_in(switch_instance.$$.fragment, 1);
					mount_component(switch_instance, switch_instance_anchor.parentNode, switch_instance_anchor);
				} else {
					switch_instance = null;
				}
			} else if (switch_value) {
				switch_instance.$set(switch_instance_changes);
			}
		},
		i(local) {
			if (current) return;
			if (switch_instance) transition_in(switch_instance.$$.fragment, local);
			current = true;
		},
		o(local) {
			if (switch_instance) transition_out(switch_instance.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(switch_instance_anchor);
			if (switch_instance) destroy_component(switch_instance, detaching);
		}
	};
}

// (33:6) {#if hasChildren}
function create_if_block_2(ctx) {
	let routerview;
	let current;
	routerview = new RouterView({ props: { depth: /*depth*/ ctx[0] + 1 } });

	return {
		c() {
			create_component(routerview.$$.fragment);
		},
		m(target, anchor) {
			mount_component(routerview, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const routerview_changes = {};
			if (dirty & /*depth*/ 1) routerview_changes.depth = /*depth*/ ctx[0] + 1;
			routerview.$set(routerview_changes);
		},
		i(local) {
			if (current) return;
			transition_in(routerview.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(routerview.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(routerview, detaching);
		}
	};
}

// (32:4) <svelte:component this={component}>
function create_default_slot(ctx) {
	let if_block_anchor;
	let current;
	let if_block = /*hasChildren*/ ctx[3] && create_if_block_2(ctx);

	return {
		c() {
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if (if_block) if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (/*hasChildren*/ ctx[3]) {
				if (if_block) {
					if_block.p(ctx, dirty);

					if (dirty & /*hasChildren*/ 8) {
						transition_in(if_block, 1);
					}
				} else {
					if_block = create_if_block_2(ctx);
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

function create_fragment(ctx) {
	let if_block_anchor;
	let current;
	let if_block = /*canRender*/ ctx[1] && create_if_block(ctx);

	return {
		c() {
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if (if_block) if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			if (/*canRender*/ ctx[1]) {
				if (if_block) {
					if_block.p(ctx, dirty);

					if (dirty & /*canRender*/ 2) {
						transition_in(if_block, 1);
					}
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let match;
	let hasChildren;
	let $route;
	component_subscribe($$self, route, $$value => $$invalidate(5, $route = $$value));
	let { depth = 0 } = $$props;
	let canRender;
	let component;

	$$self.$$set = $$props => {
		if ("depth" in $$props) $$invalidate(0, depth = $$props.depth);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*$route, depth*/ 33) {
			 $$invalidate(4, match = $route.matched[depth]);
		}

		if ($$self.$$.dirty & /*depth, $route*/ 33) {
			 $$invalidate(3, hasChildren = depth + 1 < $route.matched.length);
		}

		if ($$self.$$.dirty & /*match*/ 16) {
			 {
				$$invalidate(1, canRender = false);

				handlePromisable(
					handleThunk(match === null || match === void 0
					? void 0
					: match.redirect),
					result => {
						if (result != null) {
							tick().then(() => navigate(result, true));
						} else {
							$$invalidate(1, canRender = true);
						}
					}
				);
			}
		}

		if ($$self.$$.dirty & /*match*/ 16) {
			 {
				$$invalidate(2, component = undefined);

				handlePromisable(
					handleComponentThunk(match === null || match === void 0
					? void 0
					: match.component),
					result => {
						$$invalidate(2, component = typeof result === "object" ? result.default : result);
					}
				);
			}
		}
	};

	return [depth, canRender, component, hasChildren, match, $route];
}

class RouterView extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, not_equal, { depth: 0 });
	}
}

/* node_modules\@bjornlu\svelte-router\dist\components\Link.svelte generated by Svelte v3.38.3 */

function create_fragment$1(ctx) {
	let a;
	let a_href_value;
	let a_aria_current_value;
	let current;
	let mounted;
	let dispose;
	const default_slot_template = /*#slots*/ ctx[7].default;
	const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[6], null);

	let a_levels = [
		/*$$restProps*/ ctx[3],
		{
			href: a_href_value = /*$link*/ ctx[1].href
		},
		{
			"aria-current": a_aria_current_value = /*$link*/ ctx[1].isExactActive ? "page" : undefined
		}
	];

	let a_data = {};

	for (let i = 0; i < a_levels.length; i += 1) {
		a_data = assign(a_data, a_levels[i]);
	}

	return {
		c() {
			a = element("a");
			if (default_slot) default_slot.c();
			set_attributes(a, a_data);
			toggle_class(a, "link-active", /*$link*/ ctx[1].isActive);
			toggle_class(a, "link-exact-active", /*$link*/ ctx[1].isExactActive);
		},
		m(target, anchor) {
			insert(target, a, anchor);

			if (default_slot) {
				default_slot.m(a, null);
			}

			current = true;

			if (!mounted) {
				dispose = listen(a, "click", /*handleClick*/ ctx[2]);
				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (default_slot) {
				if (default_slot.p && (!current || dirty & /*$$scope*/ 64)) {
					update_slot(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[6], !current ? -1 : dirty, null, null);
				}
			}

			set_attributes(a, a_data = get_spread_update(a_levels, [
				dirty & /*$$restProps*/ 8 && /*$$restProps*/ ctx[3],
				(!current || dirty & /*$link*/ 2 && a_href_value !== (a_href_value = /*$link*/ ctx[1].href)) && { href: a_href_value },
				(!current || dirty & /*$link*/ 2 && a_aria_current_value !== (a_aria_current_value = /*$link*/ ctx[1].isExactActive ? "page" : undefined)) && { "aria-current": a_aria_current_value }
			]));

			toggle_class(a, "link-active", /*$link*/ ctx[1].isActive);
			toggle_class(a, "link-exact-active", /*$link*/ ctx[1].isExactActive);
		},
		i(local) {
			if (current) return;
			transition_in(default_slot, local);
			current = true;
		},
		o(local) {
			transition_out(default_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(a);
			if (default_slot) default_slot.d(detaching);
			mounted = false;
			dispose();
		}
	};
}

function instance$1($$self, $$props, $$invalidate) {
	let link;
	const omit_props_names = ["to","replace"];
	let $$restProps = compute_rest_props($$props, omit_props_names);

	let $link,
		$$unsubscribe_link = noop,
		$$subscribe_link = () => ($$unsubscribe_link(), $$unsubscribe_link = subscribe(link, $$value => $$invalidate(1, $link = $$value)), link);

	$$self.$$.on_destroy.push(() => $$unsubscribe_link());
	let { $$slots: slots = {}, $$scope } = $$props;
	
	let { to } = $$props;
	let { replace = false } = $$props;

	function handleClick(e) {
		if (e.ctrlKey || e.metaKey || e.altKey || e.shiftKey || e.button || e.defaultPrevented) {
			return;
		}

		e.preventDefault();
		navigate(to, replace);
	}

	$$self.$$set = $$new_props => {
		$$props = assign(assign({}, $$props), exclude_internal_props($$new_props));
		$$invalidate(3, $$restProps = compute_rest_props($$props, omit_props_names));
		if ("to" in $$new_props) $$invalidate(4, to = $$new_props.to);
		if ("replace" in $$new_props) $$invalidate(5, replace = $$new_props.replace);
		if ("$$scope" in $$new_props) $$invalidate(6, $$scope = $$new_props.$$scope);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*to*/ 16) {
			 $$subscribe_link($$invalidate(0, link = createLink(to)));
		}
	};

	return [link, $link, handleClick, $$restProps, to, replace, $$scope, slots];
}

class Link extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance$1, create_fragment$1, safe_not_equal, { to: 4, replace: 5 });
	}
}

export { Link, RouterView, initPathRouter };
